import { getMonth, isValid, parse, subDays } from 'date-fns';
const monthNames = {
    'pt-BR': [
        'janeiro',
        'fevereiro',
        'março',
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro',
    ],
    'en-US': [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ],
    'es-ES': [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre',
    ],
};
export function formatDate(date = new Date(), options) {
    const locale = options?.locale ?? 'pt-BR';
    const dayNames = {
        'pt-BR': ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'],
        'en-US': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        'es-ES': ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
    };
    const dayOfWeek = dayNames[locale]?.[date.getDay()] || dayNames['pt-BR'][date.getDay()];
    const day = date.getDate().toString();
    const month = monthNames[locale]?.[date.getMonth()] || monthNames['pt-BR'][date.getMonth()];
    const year = date.getFullYear().toString();
    return {
        dayOfWeek,
        day,
        month,
        year,
    };
}
const todayTranslations = {
    'pt-BR': 'Hoje',
    'en-US': 'Today',
    'es-ES': 'Hoy',
};
export const deTranslations = {
    'pt-BR': 'de',
    'en-US': 'of',
    'es-ES': 'de',
};
export function formatLongDayAndMonthOrToday(date, locale = 'pt-BR') {
    const inputDate = new Date(date);
    const today = new Date();
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    if (inputDate.getTime() === today.getTime()) {
        return todayTranslations[locale] || todayTranslations['pt-BR'];
    }
    const { dayOfWeek, day, month } = formatDate(inputDate, { locale });
    const dayOfWeekCapitalized = dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1);
    return `${dayOfWeekCapitalized}, ${day} ${deTranslations[locale] || deTranslations['pt-BR']} ${month}`;
}
export function formatShortDateWithoutTimezone(date, locale = 'pt-BR', matchToday = false) {
    const [year, month, day] = date.substring(0, 10).split('-');
    if (date === '' || date === undefined || date === null) {
        return '';
    }
    if (matchToday) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (today.getTime() === new Date(date).getTime()) {
            return todayTranslations[locale] || todayTranslations['pt-BR'];
        }
    }
    if (locale === 'en-US') {
        return `${month}/${day}/${year}`;
    }
    return `${day}/${month}/${year}`;
}
export function getCurrentDateISO() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
export function formatDateToISO(isoDate) {
    if (!isoDate)
        return '';
    return isoDate.substring(0, 10);
}
export function formatMonthAndYear(date, locale = 'pt-BR') {
    const month = monthNames[locale]?.[getMonth(date)] || monthNames['pt-BR'][getMonth(date)];
    const { year } = formatDate(date, { locale });
    const monthCapitalized = month.charAt(0).toUpperCase() + month.slice(1);
    return `${monthCapitalized} ${deTranslations[locale] || deTranslations['pt-BR']} ${year}`;
}
export function getPeriodFromDate(now, days) {
    const endDate = new Date(now);
    endDate.setHours(23, 59, 59, 999);
    return {
        from: subDays(now, days).toISOString(),
        to: endDate.toISOString(),
    };
}
export function validateDate(dateString) {
    if (!dateString)
        return false;
    const parsedDate = parse(dateString, 'dd/MM/yyyy', new Date());
    return isValid(parsedDate);
}
export function getDateWithoutTimezone(date) {
    if (!date) {
        return new Date();
    }
    const splitedDate = date.split('T')[0].split('-');
    return new Date(parseInt(splitedDate[0]), parseInt(splitedDate[1]) - 1, parseInt(splitedDate[2]));
}
